import parseCustomDateString from '~~/helpers/time/parseCustomDateString';

export default function isDateTodayOrPast(inputDateString: string): boolean {

  const inputDate = parseCustomDateString(inputDateString);
  const currentUTC = new Date();

  return inputDate.getTime() <= currentUTC.getTime();

}
